import { Route, Routes } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import {
  AccountPage,
  AccountsPage,
  AlertsPage,
  CardPage,
  CardsPage,
  DashboardPage,
  ErrorPage,
  IntegrationPage,
  IntegrationsPage,
  IntegrationsCallbackPage,
  MessageCenterPage,
  PaymentBetweenAccountsPage,
  PaymentCardSettlementPage,
  PaymentOtherBankPage,
  PaymentsPage,
  ProfilePage,
  RecipientPage,
  RecipientEditorPage,
  ReportsPage,
  StatementsPage,
  TransactionPage,
  UserPage,
  UserManagementPage,
} from '@pages';

export const Private = () => {
  return (
    <Routes>
      <Route path={RoutePaths.accounts.path} element={<AccountsPage />} />
      <Route path={RoutePaths.account.path} element={<AccountPage />} />
      <Route path={RoutePaths.accountTransaction.path} element={<TransactionPage />} />
      <Route path={RoutePaths.alerts.path} element={<AlertsPage />} />
      <Route path={RoutePaths.cards.path} element={<CardsPage />} />
      <Route path={RoutePaths.card.path} element={<CardPage />} />
      <Route path={RoutePaths.dashboard.path} element={<DashboardPage />} />
      <Route path={RoutePaths.error.path} element={<ErrorPage />} />
      <Route path={RoutePaths.callback.path} element={<IntegrationsCallbackPage />} />
      <Route path={RoutePaths.integrations.path} element={<IntegrationsPage />} />
      <Route path={RoutePaths.integration.path} element={<IntegrationPage />} />
      <Route path={RoutePaths.messages.path} element={<MessageCenterPage />} />
      <Route path={RoutePaths.payments.path} element={<PaymentsPage />} />
      <Route path={RoutePaths.paymentsOther.path}>
        <Route index element={<PaymentOtherBankPage />} />
        {/* <Route path={RoutePaths.paymentsOtherSepa.path} element={<PaymentOtherBankPage />} /> */}
      </Route>
      <Route path={RoutePaths.paymentsCard.path} element={<PaymentCardSettlementPage />} />
      <Route path={RoutePaths.paymentsInsignia.path} element={<PaymentBetweenAccountsPage />} />
      <Route path={RoutePaths.paymentsRecipient.path} element={<RecipientPage />} />
      <Route path={RoutePaths.paymentNewRecipients.path} element={<RecipientEditorPage />} />
      <Route path={RoutePaths.paymentRecipient.path} element={<RecipientEditorPage />} />
      <Route path={RoutePaths.profile.path} element={<ProfilePage />} />
      <Route path={RoutePaths.reports.path} element={<ReportsPage />} />
      <Route path={RoutePaths.statements.path} element={<StatementsPage />} />
      <Route path={RoutePaths.users.path} element={<UserManagementPage />} />
      <Route path={RoutePaths.user.path} element={<UserPage />} />
      <Route path='*' element={<ErrorPage />} />
    </Routes>
  );
};
